export * from './LatestNewsModuleFeature';
